[
    {
        "artifact.ingress.title": "Fra Reine i Lofoten [Maleri]",
        "artifact.uniqueId": "021046909815",
        "artifact.ingress.license": ["CC pdm"],
        "artifact.publishedDate": "2017-03-03T06:01:21.534Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.DEP.102",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "2B4C6C38-31D7-41BF-897E-9D5125E945D7",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-27T04:01:26.870Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1883,
        "artifact.defaultPictureIndex": 1171,
        "artifact.ingress.producer": "Sinding, Otto",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "032yjV9Ws55Y",
        "artifact.ingress.production.fromYear": 1883,
        "artifact.ingress.subjects": ["Bildende kunst"]
    },
    {
        "artifact.ingress.title": "Innseilingen til Christiania [Maleri]",
        "artifact.uniqueId": "021046909823",
        "artifact.ingress.license": ["CC pdm"],
        "artifact.publishedDate": "2017-03-03T06:01:26.516Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.DEP.101",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "E607C707-6805-4671-97EB-06C4E0C56DA4",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-27T04:01:28.781Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1874,
        "artifact.defaultPictureIndex": 1170,
        "artifact.ingress.producer": "Gude, Hans",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "022yjV9Ws5EF",
        "artifact.ingress.production.fromYear": 1874,
        "artifact.ingress.subjects": ["Bildende kunst"]
    },
    {
        "artifact.ingress.title":
            "Stortingspresident Carl Joachim Hambro [Bronse]",
        "artifact.uniqueId": "021046902766",
        "artifact.ingress.license": ["AC 1"],
        "artifact.publishedDate": "2017-02-21T06:01:23.758Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.04626",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "A084510E-6422-4A09-A82F-3B78796B06C5",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-21T04:01:59.483Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1994,
        "artifact.defaultPictureIndex": 627,
        "artifact.ingress.producer": "Christensen, Kjell Grette",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "022yjV2ttcLt",
        "artifact.ingress.production.fromYear": 1992,
        "artifact.ingress.subjects": ["Stortingspresident"]
    },
    {
        "artifact.ingress.title": "Konfirmasjonsgilde [Maleri]",
        "artifact.uniqueId": "021046909813",
        "artifact.ingress.license": ["CC pdm"],
        "artifact.publishedDate": "2017-03-03T06:01:17.101Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.DEP.103",
        "identifier.owner": "STO",
        "artifact.type": "Fineart",
        "artifact.uuid": "76AB533C-DE3C-41C3-BA16-E9D699488EE1",
        "artifact.updatedDate": "2017-08-18T04:03:22.728Z",
        "artifact.hasPictures": true,
        "artifact.pictureCount": 1,
        "artifact.ingress.production.toYear": 1887,
        "artifact.defaultPictureIndex": 1172,
        "artifact.ingress.production.fromYear": 1887,
        "artifact.ingress.producer": "Wentzel, Gustav",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "032yjV9Ws55V"
    },
    {
        "artifact.ingress.title": "Emil Stang [Byste]",
        "artifact.uniqueId": "021046898528",
        "artifact.ingress.license": ["CC pdm"],
        "artifact.publishedDate": "2017-02-13T06:01:45.260Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.02230",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "4E8A3CAF-D5F0-49F8-B0A5-B1008F233691",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-18T04:04:24.366Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1922,
        "artifact.defaultPictureIndex": 109,
        "artifact.ingress.producer": "Visdal, Jo",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "022yjUvQKRWg",
        "artifact.ingress.production.fromYear": 1922,
        "artifact.ingress.subjects": ["Bildende kunst"]
    },
    {
        "artifact.ingress.producer": "Rasmussen, Wilhelm",
        "artifact.uuid": "3341DA45-154B-4AC8-BFBE-40473199B31E",
        "artifact.pictureCount": 1,
        "artifact.defaultPictureIndex": 111,
        "artifact.type": "Fineart",
        "artifact.defaultMediaIdentifier": "032yjUvJRpq6",
        "artifact.hasPictures": true,
        "artifact.uniqueId": "021046896593",
        "artifact.ingress.title": "Wollert Konow [Byste]",
        "artifact.ingress.producerRole": "Kunstner",
        "artifact.publishedDate": "2017-02-09T06:02:04.084Z",
        "artifact.ingress.license": ["AC 1"],
        "identifier.id": "STO.K.02232",
        "artifact.hasChildren": false,
        "identifier.owner": "STO",
        "artifact.updatedDate": "2017-08-18T04:04:28.378Z",
        "artifact.ingress.subjects": ["Bildende kunst"]
    },
    {
        "artifact.ingress.title": "Wollert Konow  [Byste]",
        "artifact.uniqueId": "021046898538",
        "artifact.ingress.license": ["CC pdm"],
        "artifact.publishedDate": "2017-02-13T06:01:51.694Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.02236",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "47F2BB5A-B70D-4F56-B8CB-11B48D71504C",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-18T04:04:29.805Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1924,
        "artifact.defaultPictureIndex": 113,
        "artifact.ingress.producer": "Svor, Anders Rasmussen",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "032yjUvQKRb6",
        "artifact.ingress.production.fromYear": 1924,
        "artifact.ingress.subjects": ["Bildende kunst"]
    },
    {
        "artifact.ingress.title": "A Flower [Olje på lerret]",
        "artifact.uniqueId": "021046896548",
        "artifact.ingress.license": ["AC 1"],
        "artifact.publishedDate": "2017-02-09T06:01:49.509Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.02587",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "64D88011-4FBF-4584-9CDF-CF295CFE8023",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-18T04:02:41.837Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1993,
        "artifact.defaultPictureIndex": 72,
        "artifact.ingress.producer": "Johansen, Svein",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "032yjUvJRVaP",
        "artifact.ingress.production.fromYear": 1993,
        "artifact.ingress.subjects": ["Bildende kunst"]
    },
    {
        "artifact.ingress.title": "Cave Canem [Olje på lerret]",
        "artifact.uniqueId": "021046896560",
        "artifact.ingress.license": ["AC 1"],
        "artifact.publishedDate": "2017-02-09T06:01:52.398Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.02586",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "BA5918D3-2DB9-4AC6-A27D-2B88338EBBE0",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-18T04:02:40.253Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1993,
        "artifact.defaultPictureIndex": 71,
        "artifact.ingress.producer": "Johansen, Svein",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "032yjUvJRVeu",
        "artifact.ingress.production.fromYear": 1993,
        "artifact.ingress.subjects": ["Bildende kunst"]
    },
    {
        "artifact.ingress.title":
            "Mesna fabrikker, Lillehammer [Olje på lerret]",
        "artifact.uniqueId": "021046899449",
        "artifact.ingress.license": ["CC pdm"],
        "artifact.publishedDate": "2017-02-15T06:02:17.875Z",
        "artifact.ingress.producerRole": "Kunstner",
        "identifier.id": "STO.K.02597",
        "artifact.type": "Fineart",
        "identifier.owner": "STO",
        "artifact.uuid": "C26CD8DE-CA77-41B8-9363-03746C9F9FCC",
        "artifact.pictureCount": 1,
        "artifact.updatedDate": "2017-08-18T04:02:49.115Z",
        "artifact.hasPictures": true,
        "artifact.ingress.production.toYear": 1908,
        "artifact.defaultPictureIndex": 95,
        "artifact.ingress.producer": "Jorde, Lars",
        "artifact.hasChildren": false,
        "artifact.defaultMediaIdentifier": "022yjUvRqRTL",
        "artifact.ingress.production.fromYear": 1908,
        "artifact.ingress.subjects": ["Bildende kunst"]
    }
]
